import { Observable, of } from 'rxjs';

export function allowAll(): Observable<boolean> {
    return of(true);
}
